import {
	AfterContentChecked,
	AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Globals} from "./classes/Globals";
import {global} from 'src/globals';
import {ConfirmationService, MenuItem, MessageService, PrimeNGConfig} from 'primeng/api';
import {auth, util} from "../services";
import {SessionService} from "./services/data/session.service";

import {ConfigsService} from "./services/data/configs.service";
import {Subject, Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import _ from "lodash";
import {Project} from "./types/sherpa";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	global: Globals = global;
	manualUrl = '/rest/manual/';
	subscription: Subscription;

	public items: MenuItem[] = [];
	defaultFilters: any = null;
	userPrefs: any = {};
	reloaded = true;

	showDefaultFiltersDialog: boolean = false;
	showHelpDialog: boolean = false;
	showAgreementDialog: boolean = false;
	showUserPrefsDialog: boolean = false;

	menuFetched: boolean = false;
	authenticated: boolean = false;
	private project_id: number = -1;
	public accountItems: MenuItem[];
	private skipLoggingAgreement: boolean = true;

	constructor(
		private route : ActivatedRoute,
		private primengConfig: PrimeNGConfig,
		public messageService: MessageService,
		public sessionService: SessionService,
		private confirmationService: ConfirmationService,
		public configsService: ConfigsService,
		public cd: ChangeDetectorRef) {

		global.projectSubject = new Subject<Project>();
	}

	ngOnInit() {
		this.primengConfig.ripple = true;

		this.subscription = auth.authSubject.subscribe(ok => {

			// no access
			if(!ok) {
				this.authenticated = false;
				this.menuFetched = false;
				this.items = [];
				this.accountItems = [];
				return;
			}

			// already authenticated, no need to continue
			if(this.authenticated) {
				return;
			}

			this.authenticated = true;

			this.setMenu(-1);
			this.getMenu(); // custom

			this.getLoggingAgreement()
		});

		this.route.queryParamMap.subscribe(params => {
			this.project_id = _.toInteger(params.get("project_id"));
			if(this.project_id == 0){
				this.project_id = -1;
			}
			this.setMenu(this.project_id);
			this.getMenu();
		});

		global.projectSubject.subscribe(project => {
			if(project == null){
				this.setMenu(-1);
			}
			else {
				this.setMenu(project?.id);
			}
			this.getMenu();
		});
	}


	close() {
		this.messageService.clear('irias-toast');
	}

	getLoggingAgreement(force: boolean = false) {
		this.configsService.getLoggingAgreement().then(ok => {
			if((ok !== null && !force) || this.skipLoggingAgreement) {
				return;
			}

			let message: string = 'Om deze tool optimaal te kunnen gebruiken is het nodig om bepaalde gegevens voor u op te slaan. Het gaat hierbij om het opslaan van gekozen favoriete filteropties, en voorkeursinstellingen voor KPIs. Analyses worden nooit gelogd, totdat u zelf aangeeft de analyse op te willen slaan. Gaat u hiermee akkoord?';
			let state: string = ok ? 'Akkoord' : 'Niet akkoord';

			this.confirmationService.confirm({
				message: message,
				header: `Toestemming voor gegevensopslag`,
				icon: 'pi pi-exclamation-triangle',
				key: "agreementDialog",
				acceptLabel: 'Akkoord',
				rejectLabel: 'Niet akkoord',
				rejectButtonStyleClass: 'p-button-rounded p-button-danger p-button-text',
				acceptButtonStyleClass: 'p-button-rounded',
				accept: () => {
					this.configsService.setLoggingAgreement(true).then();
				},
				reject: () => {
					this.configsService.setLoggingAgreement(false).then(x => {
						this.showDefaultFiltersDialog = false;
					});
				}
			});
		});
	}


	getUserPrefs() {
		this.configsService.getUserPreferences().then(result => {
			this.userPrefs = result;
		});
	}

	setUserPrefs() {
		this.configsService.setUserPreferences(this.userPrefs)
			.then(result => {
				this.userPrefs = result;
				this.showUserPrefsDialog = false;
				util.toast('Uw voorkeuren zijn opgeslagen', null, 'success');
			});
	}

	getMenu() {
		this.menuFetched = false;
	}

	setMenu(project_id : number): void {

		this.items = [
			{label: 'Projecten', routerLink: '/projects'},
			{label: 'Dashboard', routerLink: '/dashboard'},
		] as MenuItem[];

		this.accountItems = [{
			label: 'Account',
			items: [{
				label: 'Hulp nodig?',
				icon: 'pi pi-fw pi-info-circle',
				command: event => {
					this.showHelpDialog = true;
				}
			},{
				label: 'Algemene voorkeuren',
				icon: 'pi pi-fw pi-cog',
				command: event => {
					this.getUserPrefs();
				}
			}, {
				label: 'Toestemmingen',
				icon: 'pi pi-fw pi-eye',
				command: event => {
					this.getLoggingAgreement(true);
				}
			}, {
				label: 'Wachtwoord',
				icon: 'pi pi-fw pi-key',
				command: event => auth.passwordChangeModal()
			}]
		}, {
			label: 'Ovit',
			items: [{
				label: 'Uitloggen',
				icon: 'pi pi-fw pi-power-off',
				command: event => this._logout()
			}]
		}] as MenuItem[];
	}

	private _logout() {
		return this.sessionService.logout()
			.then(() => {
				auth.clear(false);
				auth.loginModal('/')
			});
	}

	ngOnDestroy() {
		if(this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
